require('../cmValidationSummary.scss');

// @vendor
const PropTypes = require('prop-types');
const React = require('react');
const classnames = require('classnames');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKLink } = require('commonsComponents/OKLink');

// @components
const {
    OneLineSymbolAmount,
} = require('commonsComponents/oneLineSymbolAmount');
const BrokerMiFIDUSPersonButton = require('mifid/components/brokerMiFIDUSPersonButton/brokerMiFIDUSPersonButton');

// @helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject } = require('utilities/currencyHelper');
const { buildLinks } = require('utilities/fundsHelper');

// @constants
const {
    CM_ACTIVE_CLASS_MONEY_MARKET,
    CM_ACTIVE_CLASS_FIXED_INCOME,
    CM_ACTIVE_CLASS_EQUITY,
    CM_ACTIVE_CLASS_REAL_ASSETS,
    CM_EUR_CURRENCY,
    CM_OPERATION_TYPE_TRASPASS,
} = require('../../../constants/constants');

class CmValidationRowSummary extends React.Component {
    constructor(props) {
        super(props);
        this.getRowAmount = this.getRowAmount.bind(this);
        this.handleBuy = this.handleBuy.bind(this);
    }

    getRowClass(assetClass) {
        const customClass = classnames('cm-funds-summary__row', {
            ['cm-funds-summary__row--money-market']:
                assetClass === CM_ACTIVE_CLASS_MONEY_MARKET,
            ['cm-funds-summary__row--fixed-income']:
                assetClass === CM_ACTIVE_CLASS_FIXED_INCOME,
            ['cm-funds-summary__row--equity']:
                assetClass === CM_ACTIVE_CLASS_EQUITY,
            ['cm-funds-summary__row--real-assets']:
                assetClass === CM_ACTIVE_CLASS_REAL_ASSETS,
        });

        return customClass;
    }

    getRowAmount(subAssetClassFundAmount) {
        return {
            amount: subAssetClassFundAmount,
            currency: CM_EUR_CURRENCY,
        };
    }

    handleBuy(product, subProductType) {
        return window.open(
            `/myprofile/broker/buyInvestmentFunds/${product}-${subProductType}-1`,
        );
    }

    productFileLink(isin) {
        return buildLinks(isin);
    }

    render() {
        const {
            key,
            assetClassId,
            assetClassDesc,
            subAssetClassDesc,
            legalDocument,
            subAssetClassFundAmount,
            orderType,
            subAssetClassIsin,
            fundProduct,
            fundSubproduct,
            subAssetClassFundName,
            onHandleDocumentClick,
            isTransferWithMoney,
            hasFundProductLink,
            secId,
        } = this.props;
        const rowClass = this.getRowClass(assetClassId);
        const customClass = classnames({
            'cm-funds-summary__cell--fourth': this.props.showBuyButton,
            'cm-funds-summary__cell--last': !this.props.showBuyButton,
        });
        const showBuyButton = this.props.showBuyButton ? (
            <OKTableCell className="cm-funds-summary__cell--button cm-funds-summary__cell hidden-xs">
                <BrokerMiFIDUSPersonButton
                    modifier="secondary"
                    size="compact"
                    onClick={() => this.handleBuy(fundProduct, fundSubproduct)}
                    isinId={subAssetClassIsin}
                >
                    <div className="broker-products-table-row__buy-button">
                        {formatText('broker-myInvestmentsSuscribeLink')}
                    </div>
                </BrokerMiFIDUSPersonButton>
            </OKTableCell>
        ) : null;

        const orderTypeText = orderType.startsWith(CM_OPERATION_TYPE_TRASPASS)
            ? formatText('brokerCM-brokerCM_orderTypeTransfer')
            : formatText('brokerCM-brokerCM_orderTypeLiquidity');
        let orderTypeColumn;
        if (isTransferWithMoney) {
            orderTypeColumn = (
                <OKTableCell className="cm-funds-summary__cell cm-funds-summary__cell--third-additional hidden-xs">
                    {orderTypeText}
                </OKTableCell>
            );
        }

        let subAssetClassFundNameContent = (
            <span className="cm-funds-summary__cell-content-first">
                {subAssetClassFundName}
            </span>
        );

        if (hasFundProductLink) {
            subAssetClassFundNameContent = (
                <span className="cm-funds-summary__cell-content-first">
                    <OKLink target="_blank" to={this.productFileLink(secId)}>
                        {subAssetClassFundName}
                    </OKLink>
                </span>
            );
        }

        return (
            <OKTableRow key={key}>
                <OKTableCell
                    className={
                        'cm-funds-summary__cell cm-funds-summary__cell--first ' +
                        rowClass
                    }
                >
                    <span className="cm-funds-summary__cell-content-first visible-xs">
                        {assetClassDesc + ' - ' + subAssetClassDesc}
                    </span>
                    {subAssetClassFundNameContent}
                    <div className="cm-funds-summary__portfolio--footer visible-xs">
                        <div className="cm-funds-summary__icon-wrapper">
                            <FormattedText
                                value="brokerCM-fundsSummaryLegalDocumentHeader"
                                className="cm-funds-summary__header-document-content"
                            />
                            <OKButton
                                modifier="additional-action-secondary"
                                size="small"
                                loaderColor="dark"
                                loaderSize="small"
                                onClick={() =>
                                    onHandleDocumentClick(subAssetClassIsin)
                                }
                            >
                                <i className="icon-link-externo cm-funds-summary__icon"></i>
                            </OKButton>
                        </div>
                        <div className="cm-funds-summary__amount-wrapper">
                            <OneLineSymbolAmount
                                amountObject={{
                                    amount: subAssetClassFundAmount,
                                    currency: CM_EUR_CURRENCY,
                                }}
                                className="cm-funds-summary__cell-content-last"
                                language={getLanguage()}
                                amountObjectFormatted={formatAmountObject(
                                    subAssetClassFundAmount,
                                    true,
                                )}
                            />
                        </div>
                    </div>
                    <div className="cm-funds-summary__gutter-spacing visible-xs"></div>
                </OKTableCell>
                <OKTableCell className="cm-funds-summary__cell cm-funds-summary__cell--second hidden-xs">
                    <span className="cm-funds-summary__cell-content-second">
                        {assetClassDesc + ' - ' + subAssetClassDesc}
                    </span>
                </OKTableCell>
                <OKTableCell className="cm-funds-summary__cell cm-funds-summary__cell--third hidden-xs">
                    {legalDocument}
                </OKTableCell>
                {orderTypeColumn}
                <OKTableCell
                    className={`cm-funds-summary__cell ${customClass} hidden-xs`}
                >
                    <OneLineSymbolAmount
                        amountObject={this.getRowAmount(
                            subAssetClassFundAmount,
                        )}
                        className="cm-funds-summary__cell-content-last"
                        language={getLanguage()}
                        amountObjectFormatted={formatAmountObject(
                            this.getRowAmount(subAssetClassFundAmount),
                            true,
                        )}
                    />
                </OKTableCell>
                {showBuyButton}
            </OKTableRow>
        );
    }
}

CmValidationRowSummary.propTypes = {
    key: PropTypes.number,
    assetClassId: PropTypes.string,
    assetClassDesc: PropTypes.string,
    subAssetClassDesc: PropTypes.string,
    legalDocument: PropTypes.object,
    subAssetClassFundAmount: PropTypes.string,
    subAssetClassIsin: PropTypes.string,
    subAssetClassFundName: PropTypes.string,
    fundProduct: PropTypes.string,
    fundSubproduct: PropTypes.string,
    onHandleDocumentClick: PropTypes.func,
    showBuyButton: PropTypes.func,
    isTransferWithMoney: PropTypes.bool,
    orderType: PropTypes.string,
    hasFundProductLink: PropTypes.bool,
    secId: PropTypes.string,
};

module.exports = CmValidationRowSummary;
